import { render } from "./EventDetails.vue?vue&type=template&id=0e3422f6"
import script from "./EventDetails.vue?vue&type=script&lang=ts"
export * from "./EventDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script